export default [
  { title: "Product", icon: "", link: "/docs/api-services/product" },
  { title: "Top UP", icon: "", link: "/docs/api-services/top-up" },
  { title: "User Balance", icon: "", link: "/docs/api-services/user-balance" },
  { title: "Dokumen", icon: "", link: "/docs/api-services/document" },
];
